const path = 'redux/coSellOpportunity';
export const CO_SELL_OPPORTUNITIES_LOADED = `${path}/CO_SELL_OPPORTUNITIES_LOADED`;
export const CO_SELL_OPPORTUNITY_LOADED = `${path}/CO_SELL_OPPORTUNITY_LOADED`; 